<template>
  <div class="text-center">
    <form v-if="!checkItemInOrder()" @submit.prevent="submit">
      <div v-if="reservationMode==='day'">
        <m-reservation-month-manager @month="setMonth"/>
        <div class="calendar">
          <div class="day" v-t="`product.reservation.week.saturday`"></div>
          <div class="day" v-t="`product.reservation.week.sunday`"></div>
          <div class="day" v-t="`product.reservation.week.monday`"></div>
          <div class="day" v-t="`product.reservation.week.tuesday`"></div>
          <div class="day" v-t="`product.reservation.week.wednesday`"></div>
          <div class="day" v-t="`product.reservation.week.thursday`"></div>
          <div class="day" v-t="`product.reservation.week.friday`"></div>
          <m-reservation-day @selectedDay="setSelectedDays" v-for="day in currentMonthAvailableTimes"
                             :reservation-mode="reservationMode"
                             :selectedDays="selectedDays" :day="day"/>
          <div v-if="currentMonthAvailableTimes.length == 0">
            <p v-t="`product.reservation.not_item`"></p>
          </div>
        </div>
      </div>

      <div v-if="reservationMode==='hour'">
        <reservation-day-selector @day="getReservationData"/>

        <div class="reservation-hour-item-section">
          <m-reservation-day @selectedDay="setSelectedHourItem" v-for="day in availableTimes"
                             :reservation-mode="reservationMode"
                             :selectedDays="selectedDays" :day="day"/>
          <div v-if="availableTimes.length == 0">
            <p v-t="`product.reservation.not_item`"></p>
          </div>
        </div>
      </div>

      <hr>
      <div class="container">
        <m-reservation-extra-options @extraItems="extraItems" :reservation-rule="reservation_rules"/>
      </div>
      <div class="text-center">
        <button class="btn btn-primary rounded-pill px-5" type="submit" v-t="`product.reservation.submit`"></button>
      </div>


      <teleport to="body">
        <div class="modal fade" id="authenticate" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <m-login1 @login="redirectController" :redirect="false"/>
              </div>
            </div>
          </div>
        </div>
      </teleport>

      <teleport to="body">
        <div class="modal fade show" id="cashOnDelivery" tabindex="-1"
             aria-labelledby="exampleModalLabel"
             aria-hidden="true">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">

                <m-un-authenticated-shopping-cart2
                    v-if="showUnAuthenticatedComponent"
                    :hide-refresh-shopping-cart-button="false"
                    default-gate="cashOnDelivery"
                    :address-required="false"
                    :order_description_prop="false"
                    :postal_code_prop="false"
                    :activeShoppingCartForm="true"
                    :hide-signup-button="false"
                />

              </div>
            </div>
          </div>
        </div>
      </teleport>


    </form>
    <div v-else>
      <p v-t="`product.reservation.in_shopping_cart`"></p>
      <m-a :href="{name:'ShoppingCart'}">
        <button class="btn btn-primary" v-t="`product.single.shopping_cart`"></button>
      </m-a>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import $ from 'jquery'
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

import {
  addMonths,
  findFirstAndLastDayOfMonth,
  getNextMonths
} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Reservation";
import mReservationMonthManager from './ReservationMonthManager.vue'
import mReservationDay from './ReservationDay.vue'
import mReservationExtraOptions from '../ExtraItems/ReservationExtraOptions.vue'
import ReservationDaySelector from "../Calendar/ReservationDaySelector.vue";
import mLogin1 from "../../Authentication/Login/Login1.vue";
import mA from '../../Tags/A.vue'
import mUnAuthenticatedShoppingCart2 from "../../UnAuthenticatedShoppingCart/UnAuthenticatedShoppingCart2.vue";
import {addUnAuthItem} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";


export default {
  name: "ReservationCalendar1",
  components: {
    ReservationDaySelector,
    mReservationMonthManager,
    mReservationDay,
    mReservationExtraOptions,
    mLogin1,
    mA,
    mUnAuthenticatedShoppingCart2,
  },
  props: {
    product: {}
  },
  data() {
    return {
      month: '',
      selectedDays: [],
      reservation_rules: [],
      selectedExtraItems: [],
      showUnAuthenticatedComponent: false,
    }
  },
  computed: {
    ...mapGetters({
      availableTimes: "Reservation/getReservationTimes",
      order: "ShoppingCart/getUserOrderUnpaidItems",
      authenticated: "User/isAuthenticated"
    }),
    currentMonthAvailableTimes() {
      let currentMonthShamsi = new Date(this.month).toLocaleDateString('fa-IR-u-nu-latn', {month: '2-digit'})

      if (Object.keys(this.availableTimes).length === 0) {
        return []
      }


      let items = this.availableTimes.filter(item => {
        let itemStartDate = item.start.split(' ')[0]
        let itemStartDateMonthShamsi = new Date(itemStartDate).toLocaleDateString('fa-IR-u-nu-latn', {month: '2-digit'})
        return parseInt(currentMonthShamsi) === parseInt(itemStartDateMonthShamsi)
      })


      let findFirstDayOfTheIndex = new Date(items[0].start.split(' ')[0]).getDay()

      for (let i = 0; i <= findFirstDayOfTheIndex; i++) {
        items.unshift({start: '', end: '', type: 1,})
      }

      return items


    },
    reservationMode() {
      let rawReservationRules = this.product.reservation_rules

      let reservationRules = JSON.parse(rawReservationRules.json);
      if (!reservationRules.hasOwnProperty('reservation_mode')) {
        toast('خطا در شکل قوانین زمان ذخیره شده.', 'خطا در شکل قوانین زمان ذخیره شده.')
      }

      return reservationRules.reservation_mode
    }
  },
  methods: {
    addUnAuthItem,
    addMonths,
    getNextMonths,
    findFirstAndLastDayOfMonth,
    findIndexOfSelectedDays(availableTimes, selectedDays) {
      let result = []
      selectedDays.forEach(item => {
        let itemIndex = availableTimes.indexOf(item)
        result.push(itemIndex)
      })
      return result
    },
    validateSelectedRange(availableTimes, selectedDays) {
      let selectedDaysIndexRange = this.findIndexOfSelectedDays(availableTimes, selectedDays)
      let minIndex = Math.min(...selectedDaysIndexRange)
      let maxIndex = Math.max(...selectedDaysIndexRange)

      let checker = true;

      for (let i = minIndex; i <= maxIndex; i++) {
        let item = availableTimes[i];
        if (item.reserved) {
          checker = false
          break
        }
      }


      return checker
    },
    generateDayBetweenTwoIndex(availableTimes, selectedDays) {
      let selectedDaysIndexRange = this.findIndexOfSelectedDays(availableTimes, selectedDays)
      let minIndex = Math.min(...selectedDaysIndexRange)
      let maxIndex = Math.max(...selectedDaysIndexRange)

      let result = []

      for (let i = minIndex; i <= maxIndex; i++) {
        let item = availableTimes[i];
        result.push(item)
      }
      return result
    },
    setMonth(data) {
      this.month = data
    },
    setSelectedHourItem(day) {
      this.selectedDays = [day]
    },
    setSelectedDays(day) {

      if (this.selectedDays.indexOf(day) > -1) {
        return 0
      }

      if (this.selectedDays.length >= 2) {
        this.selectedDays = []
      }

      this.selectedDays.push(day)

      if (this.selectedDays.length === 2) {
        let result = this.validateSelectedRange(this.availableTimes, this.selectedDays);
        if (result === false) {
          this.selectedDays.pop()
        } else {
          this.selectedDays = this.generateDayBetweenTwoIndex(this.availableTimes, this.selectedDays)
        }
      }

    },
    extraItems(data) {
      const mode = data.mode
      const itemData = data.data
      if (mode) { // add
        this.selectedExtraItems.push(itemData)
      } else { // remove
        const itemIndex = this.selectedExtraItems.indexOf(itemData)
        this.selectedExtraItems.splice(itemIndex, 1)
      }
    },
    async standardAddToCart(form) {
      if (this.authenticated) {
        await this.$store.dispatch("ShoppingCart/addItem", form).then(res => {
          this.$router.push({name: "ShoppingCart"})
        })
        this.$forceUpdate()
      } else {
        $('#authenticate').modal('show')
      }
    },
    checkProductCategoryInsideCashOnDelivery() {
      let productCategories = this.product.category
      let cashOnDeliveryCategories = findAttributeOnSiteInfo('cash_on_delivery_categories')

      if (cashOnDeliveryCategories === false || productCategories.length == 0) {
        return false
      }

      productCategories = productCategories.map(item => item.id)
      cashOnDeliveryCategories = cashOnDeliveryCategories.map(item => item.id)

      let result = false;

      productCategories.forEach(item => {
        if (cashOnDeliveryCategories.indexOf(item) > -1) {
          result = true
        }
      })


      return true
    },
    async submit() {
      const extraOptions = this.selectedExtraItems
      const days = this.selectedDays

      if (this.reservationMode == 'day') {
        if (days.length <= 1) {
          toast('هیج بازه تاریخی انتخاب نشده است', 'هیج بازه تاریخی انتخاب نشده است', 'danger')
          return false
        }
      }

      if (this.reservationMode == 'hour') {
        if (days.length != 1) {
          toast('هیج تاریخی انتخاب نشده است', 'هیج تاریخی انتخاب نشده است', 'danger')
          return false
        }
      }

      const form = {
        product: [
          {
            id: this.product.id,
            reservation: days,
            reservation_extra_options: extraOptions
          }
        ]
      }


      if (this.checkProductCategoryInsideCashOnDelivery()) {
        this.showUnAuthenticatedComponent = false
        await localStorage.removeItem('products')
        let reservationData = {
          reservation: days,
          reservation_extra_options: extraOptions
        }
        await this.addUnAuthItem(this.product, null, reservationData)


        await $('#cashOnDelivery').modal('show')
        this.showUnAuthenticatedComponent = true


      } else {
        await this.standardAddToCart(form)
      }
    },
    checkItemInOrder() {
      let checker = false
      this.order.forEach(item => {
        if (this.product.id == item.product.id) {
          checker = true
        }
      })
      return checker
    },
    reservationDayModeTimes() {
      let today = new Date();
      let monthRange = this.getNextMonths(today, 3)

      let firstMonthFirstLastDay = this.findFirstAndLastDayOfMonth(monthRange[0])
      let lastMonthFirstLastDay = this.findFirstAndLastDayOfMonth(monthRange[2])


      return {
        product_id: this.product.id,
        start: firstMonthFirstLastDay['firstDay'].toISOString().split('T')[0] + ' 00:00:00',
        end: lastMonthFirstLastDay['lastDay'].toISOString().split('T')[0] + ' 23:59:59',
      }
    },
    reservationHourModeTimes(date = null) {
      let start = new Date(); // get the current date
      let end = new Date(); // create a new date object
      if (date != null) {
        start = date;
        end = date;
      }

      return {
        product_id: this.product.id,
        start: start.toISOString().split('T')[0] + ' 00:00:00',
        end: end.toISOString().split('T')[0] + ' 23:59:59',
      }
    },
    getReservationModeTimes(date = null) {

      const reservationMode = this.reservationMode

      if (reservationMode === 'day') {
        return this.reservationDayModeTimes()
      }
      if (reservationMode === 'hour') {
        return this.reservationHourModeTimes(date)
      }
      return false
    },
    async getReservationData(date = null) {
      this.$store.commit('Reservation/setReservationTimes', {})
      const form = this.getReservationModeTimes(date)
      return await this.$store.dispatch('Reservation/getProductAvailableTimes', form)
    },
    redirectController(data) {
      $('#authenticate').modal('hide')
      toast('برای ثبت نوبت دوباره بر روی دکمه ثبت  کلیک کنید.', 'برای ثبت نوبت دوباره بر روی دکمه ثبت  کلیک کنید.')
    }
  },
  async mounted() {
    let res = await this.getReservationData()
    this.reservation_rules = res.data.data.reservation_rules;

  }
}
</script>

<style scoped>
.reservation-hour-item-section {
  height: 350px;
  overflow: auto;
}

.calendar {
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.day {
  position: relative;
  width: calc(13.2857%);
  display: flex;
  margin: 1px;
  justify-content: center;
  align-items: center;
  font-size: 13px;
}

</style>